import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

type Params = {
  id: string;
  ctgy: string;
};

export function AdminReplyWrite(routeProps: any) {
  const { match, location } = routeProps;
  const [reply, setReply] = useState<any>();
  const { id, ctgy } = match.params as Params;
  const history = useHistory();
  const [userText, setUserText] = useState(window.localStorage.getItem('name') || '');
  const [title, setTitle] = useState<string>('');
  const [conText, setConText] = useState<string>('');
  const dispatch = useDispatch();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    if (+id > 0) {
      server
        .getReplyId(id)
        .then((payload) => {
          setReply(routeProps.location.state.replyAdd);
          setConText(payload.content);
          setTitle(payload.subject);
        })
        .catch((error) => {
          console.log('답글 불러오기 에러 : ', error);
        });
    }
  }, []);

  const onClickValidation = () => {
    if (!title) {
      dispatch(toast.error({ message: '제목을 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (!conText) {
      dispatch(toast.error({ message: '내용을 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    onClickSave();
  };

  const onClickSave = () => {
    if (reply === false) {
      server
        .updateReply(ctgy, id, {
          subject: title,
          content: conText,
        })
        .then(() => {
          routeProps.history.push(`/admin/board/adminReplyView/${ctgy}/${id}`);
        })
        .catch((error) => {
          console.log(' 답글 수정 error : ', error);
        });
    } else {
      server
        .writeReplyBoard(ctgy, id, {
          subject: title,
          content: conText,
          attach1: '',
          attach2: '',
          attach3: '',
          attach4: '',
          attach5: '',
        })
        .then(() => {
          routeProps.history.push(`/admin/board/${ctgy}`);
        })
        .catch((error) => {
          console.log('답글 작성 에러 : ', error);
        });
    }
  };

  return (
    <main className="board-add wrapper">
      <div className="title">
        <h1>답글 작성</h1>
        <div className="buttons">
          <button
            className="btn-sub"
            type="button"
            onClick={() => {
              routeProps.history.goBack();
            }}
          >
            취소
          </button>
          <button type="button" onClick={() => onClickValidation()}>
            등록
          </button>
        </div>
      </div>
      <div className="content">
        <ul className="inputs">
          <li>
            <span>제목</span>
            <input
              className="full"
              type="text"
              value={title}
              onChange={(e: any) => {
                setTitle(e.target.value);
              }}
            />
          </li>
          <li>
            <span>작성자</span>
            <input type="text" readOnly value={userText} />
          </li>
          {/* <li>
            <span>첨부파일</span>
            <div className="input-file-container">
              <input className="input-files" multiple id="file01" type="file" />
            </div>
            <small className="file-return" />
          </li> */}
          <li>
            <textarea
              name=""
              id=""
              rows={20}
              value={conText}
              onChange={(e: any) => {
                setConText(e.target.value);
              }}
            />
          </li>
        </ul>
      </div>
    </main>
  );
}
